import * as React from "react";
import { type SVGProps } from "react";
const SvgEyeBlock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={15}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#eye-block_svg__a)">
      <path
        d="M14.88 5.646c-.963-1.277-2.099-2.309-3.35-3.016l1.356-1.568a.643.643 0 0 0-.976-.839l-1.59 1.838a7.939 7.939 0 0 0-2.819-.524c-2.868 0-5.467 1.565-7.385 4.106a.592.592 0 0 0 0 .707C1.172 7.75 2.43 8.852 3.83 9.563l-1.19 1.371a.64.64 0 0 0 .487 1.063.642.642 0 0 0 .488-.224l1.467-1.696c.776.248 1.586.38 2.414.38 2.866 0 5.465-1.565 7.382-4.107a.582.582 0 0 0 .003-.704Zm-10.53.147a3.159 3.159 0 0 1 2.943-2.936A3.16 3.16 0 0 1 9.2 3.35l-.966 1.12a1.704 1.704 0 0 0-2.43 1.42c-.025.393.083.76.285 1.058l-.97 1.12a3.139 3.139 0 0 1-.77-2.275Zm6.296.41A3.168 3.168 0 0 1 7.704 9.14a3.135 3.135 0 0 1-1.553-.297l1.025-1.185a1.704 1.704 0 0 0 2.019-1.555 1.694 1.694 0 0 0-.092-.674l1.022-1.173a3.13 3.13 0 0 1 .521 1.948Z"
        fill="#8181A5"
      />
    </g>
    <defs>
      <clipPath id="eye-block_svg__a">
        <path fill="#fff" d="M0 0h15v12H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEyeBlock;
